import './ContentPage.css';
import Footer from '../components/Footer.js'; 

const Confidentiality = ({ title, content }) => {
  return (
    <div>
    <div className="content-page">
      <section className="content-hero">
        <h1 className="hero-title">Confidentiality Pledge</h1>
        <div className="hero-decor"></div>
      </section>

      <section className="content-section">
        <div className="content-card reveal active">
          <div className="text-container">
            <p className="content-text">We promise to

keep strictly confidential all information provided by clients,

use information solely for carrying out clients' work and

maintain confidentiality of all workings and results derived from clients' work.</p>
          </div>
          <div className="interactive-element">
            <div className="hover-circle"></div>
            <div className="hover-circle"></div>
          </div>
        </div>
      </section>

    </div>
            <Footer />
    </div>
  );
};

export default Confidentiality;